// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "v1.45.1.5-4-g59289b38e8-dirty",
    "hash": "g59289b38e8",
    "distance": 4,
    "tag": "v1.45.1.5",
    "semver": null,
    "suffix": "4-g59289b38e8-dirty",
    "semverString": "",
    "version": "1.45.1"
};
/* tslint:enable */
